import { SupportedModelCategories } from '../../common/utils/catalogUtils.js';
import { CatalogProductSelectionForm } from './CatalogProductSelectionForm.js';
import { CatalogProductSelectionFormWrapper } from './CatalogProductSelectionFormWrapper.js';
import { getSelectedCatalogProducts } from './CatalogProductSelectionUtils.js';
import type { DeviceSelection } from './CatalogProductSelectionFormWrapper.js';
import type { CatalogProduct } from '../../common/utils/catalogUtils.js';
import type { Catalog } from '../../generated/api/catalog';

import './CatalogProductsSelection.scss';

export interface CatalogProductsSelectionProps {
  preSelectedProducts?: Record<string, CatalogProduct[]>;
  onSetProductsForCatalog: (products: Record<string, CatalogProduct[]>, removedDiscontinuedDevices: string[]) => void;
  contractPeriod?: number;
  imagesBaseUrl: string;
  catalogProducts: Record<string, CatalogProduct[]>;
  catalog: Catalog;
  preRemovedDiscontinuedDevices?: string[];
}

export const CatalogProductsSelection = ({
  catalogProducts,
  preSelectedProducts,
  imagesBaseUrl,
  contractPeriod,
  onSetProductsForCatalog,
  catalog,
  preRemovedDiscontinuedDevices,
}: CatalogProductsSelectionProps) => {
  const handleSubmit = (data: Readonly<DeviceSelection>) => {
    const removedDiscontinuedDevices = data.removedDiscontinuedDevices || [];
    const selectedProductCodes = data.selectedProductCodes || [];
    const selectedCatalogProducts = getSelectedCatalogProducts(catalogProducts, selectedProductCodes);
    onSetProductsForCatalog(selectedCatalogProducts, removedDiscontinuedDevices);
  };

  const preSelectedProductCodes = SupportedModelCategories.flatMap(cat => {
    return preSelectedProducts ? preSelectedProducts[cat]?.map(prod => prod.code) : [];
  }).filter(prod => prod);

  return (
    <CatalogProductSelectionFormWrapper
      preSelected={preSelectedProductCodes}
      preRemovedDiscontinuedDevices={preRemovedDiscontinuedDevices ?? []}
      onSubmit={handleSubmit}
    >
      <div className="of-catalog-products-selection">
        <CatalogProductSelectionForm
          catalogProducts={catalogProducts}
          imagesBaseUrl={imagesBaseUrl}
          contractPeriod={contractPeriod}
          catalog={catalog}
        />
      </div>
    </CatalogProductSelectionFormWrapper>
  );
};
